import styled from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const TABLE_HEAD_SORT_ICON_SIZE = pxToRem(16);
export const TABLE_HEAD_SORT_FLEX_GAP = themeGet('spacing.sm');
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${TABLE_HEAD_SORT_ICON_SIZE};
  height: ${TABLE_HEAD_SORT_ICON_SIZE};
  opacity: 1;
  transition: opacity var(--table-loading-transition);

  ${(props) => props.$loading &&
    `
    opacity: 0.2;
  `}
`;
export const StyledTypography = styled(Typography) `
  color: ${themeGet('colors.text.100')};
`;
export const SortButton = styled.button `
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  height: var(--table-head-cell-height);

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.200')};
    transition: all 175ms ease-in-out;
  }

  &:hover {
    [data-icon='falcon'] {
      opacity: 1;
      color: ${(props) => (props.$active ? themeGet('colors.gray.700') : themeGet('colors.gray.500'))};
    }

    ${StyledTypography} {
      color: ${themeGet('colors.text.300')};
    }
  }

  ${(props) => props.$active &&
    `
    [data-icon='falcon'] {
      color: ${themeGet('colors.gray.400')};
    }

    ${StyledTypography} {
      color: ${themeGet('colors.text.300')};
    }}
  `}
`;
export const HeaderTextContainer = styled.div `
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: ${TABLE_HEAD_SORT_FLEX_GAP};
`;
